// extracted by mini-css-extract-plugin
export default {"BrokerExpand":"BrokerExpand_BrokerExpand__I8ddX","BrokerExpandButton":"BrokerExpand_BrokerExpandButton__p+0An","BrokerExpandSection":"BrokerExpand_BrokerExpandSection__LXjXF"};